import React, { useEffect } from "react";
import MenuImage from "../../components/MenuImage/MenuImage";
import "../IndexPage/IndexPage.css";

function WhiskyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="whisky-background"></div>
      <div className="card-container">
        {/* Whisky: misma imagen en todos los idiomas (sin versión EN/JA). */}
        <MenuImage
          width="1061" height="1500"
          className="pdf-sake"
          es="img/whisky.webp"
          alt="Whisky japonés"
        />
      </div>
    </div>
  );
}

export default WhiskyPage;
